import * as React from 'react';
import { TApiProcessEntity } from '../../types/Process';
import { ImageList, ImageListItem, ImageListItemBar, useMediaQuery, useTheme } from '@mui/material';
import { useProcessListStyles } from './ProcessList.styles';
import { Link } from 'react-router-dom';
import { reverse } from 'named-urls';
import { routes } from '../../Routes';
import Image from '../cms/Image';
import { simpleDateFormat } from '../../Helpers';

interface IProcessListProps {
  processes?: Array<TApiProcessEntity>;
}

const ProcessList: React.FC<IProcessListProps> = ({
  processes
}): JSX.Element => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useProcessListStyles({});

  return (
    <ImageList rowHeight={180} cols={isXs ? 2 : 4} className={classes.gridList}>
      {(processes ?? []).map((process) => {
        return (
          <ImageListItem key={process.id}>
            <Link
              to={reverse(routes.processItem, {
                id: process.id
              })}
            >
              {process.image ? (
                <Image image={{
                  url: process.image as string,
                  name: process.name as string
                }} tileImage={true}/>
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <i
                    className='fas fa-sitemap'
                    style={{ fontSize: '150px', color: 'lightgray' }}
                  />
                </div>
              )}

              <ImageListItemBar
                title={process.name}
                subtitle={simpleDateFormat(process.updateDate)}
              />
            </Link>
          </ImageListItem>
        );
      })}
    </ImageList>
  );
};

export default ProcessList;
